import Container from "@components/Container";
import MinimalFooter from "@components/MinimalFooter";
import MinimalHeader from "@components/MinimalHeader";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import clsx from "clsx";
import { FC, PropsWithChildren } from "react";

const ApplicationLayout: FC<
  PropsWithChildren<{
    border?: boolean;
    centered?: boolean;
    className?: string;
  }>
> = ({ children, border, className, centered = true }) => {
  const { partner } = usePartnerContext();
  return (
    <div className="flex flex-col min-h-screen">
      <MinimalHeader border={border} partner={partner} />
      <Container
        padding
        className={clsx(
          centered ? "grow flex m:items-center" : "grow",
          className,
        )}
      >
        {children}
      </Container>
      <MinimalFooter isPartner={!!partner} isFullWidth />
    </div>
  );
};

export default ApplicationLayout;
